import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// Global axios interceptor — attach token from localStorage to ALL axios calls
axios.interceptors.request.use((config) => {
  const token = localStorage.getItem('session_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('session_token');
    }
    return Promise.reject(error);
  }
);

const api = axios.create({
  baseURL: BACKEND_URL,
  withCredentials: true,
});

// Also add interceptors to the named instance
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('session_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('session_token');
    }
    return Promise.reject(error);
  }
);

export const setAuthToken = (token) => {
  if (token) {
    localStorage.setItem('session_token', token);
  } else {
    localStorage.removeItem('session_token');
  }
};

export const getAuthToken = () => localStorage.getItem('session_token');

export const clearAuth = () => {
  localStorage.removeItem('session_token');
};

export default api;
